module.exports = __webpack_public_path__ + "img/拉手锁1.dce6bc2f.jpg";